import { useEffect } from "react";
import { Link } from "react-router-dom";
import { CreditCard, MessageCircle, RefreshCw, ShoppingBag } from "lucide-react";

import SystemPageShell from "./SystemPageShell";

export default function PaymentFailurePage() {
  useEffect(() => { document.title = "Payment Issue | SugaLumps"; }, []);
  return (
    <SystemPageShell
      eyebrow="Payment didn't go through"
      title="Your order hasn't been charged."
      copy="Something prevented us from completing your payment. You can try again without rebuilding your order."
      icon={<CreditCard size={38} strokeWidth={1.6} />}
      actions={(
        <>
          <Link className="sl-system-button primary" to="/checkout"><RefreshCw size={16} /> Try Payment Again</Link>
          <Link className="sl-system-button secondary" to="/cart"><ShoppingBag size={16} /> Back to Cart</Link>
          <Link className="sl-system-button secondary" to="/contact"><MessageCircle size={16} /> Contact Us</Link>
        </>
      )}
    />
  );
}
